import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_proxy_list = (page, per_page, name, status) => {
  return api.post(`${ApiEndpointConstants.GETPROXYLIST}`, {
    page,
    per_page,
    name,
    status,
  });
};
